export const TABLE_PAGE_SIZES = [5, 10, 25, 50];
export const DEFAULT_ROWS_PER_PAGE = 50;
export const TABLE_FIXED_HEIGHT_PX = 512;
